import React from "react";
import PropTypes from "prop-types";
import { Field, reduxForm, destroy } from "redux-form";
import { reduxFormInputType } from "custom-prop-types";
import styles from "components/settings/user-settings.scss";
import { Button } from "components/common/button";

const StatelessPasswordForm = ({ onSavePassword }) => (
  <div className={ styles["form-container"] }>
    <form onSubmit={ (e) => { e.preventDefault(); onSavePassword(); destroy("userPasswordForm"); } }>
      <h1>Change your password</h1>
      { renderInput("Current Password", "currentPassword") }
      { renderInput("New password", "newPassword") }
      { renderInput("Confirm new password", "newPasswordRepeated") }
      <Button primary type="submit">Save New Password</Button>
    </form>
  </div>
);

StatelessPasswordForm.propTypes = { onSavePassword: PropTypes.func.isRequired };

export const UserPasswordSettings = reduxForm({ form: "userPasswordForm" })(StatelessPasswordForm);

const renderInput = (title, name) => (
  <div className={ styles["fields-container"] }>
    <h4>{ title }</h4>
    <Field
      component={ textInput }
      name={ name }
      placeholder={ title }
    />
  </div>
);

const textInput = (props) => (
  <div className={ styles["fields-container__row"] }>
    <input { ...props.input } className={ styles.fields } placeholder={ props.placeholder } type="password" />
  </div>
);

textInput.propTypes = {
  input: reduxFormInputType.isRequired,
  placeholder: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/settings/user-password-settings.jsx